import { useEffect, useState } from "react";

const MESSAGES = [
  "Free nationwide shipping on orders over R 2 000",
  "Hand-finished HD lace — undetectable hairlines",
  "30-day exchange on uncut lace wigs",
  "Pay later with Payflex • Yoco • Ozow",
];

export default function AnnouncementBar() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % MESSAGES.length), 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="announcement-bar" className="bg-charcoal text-ivory text-[11px] tracking-luxe uppercase">
      <div className="max-w-7xl mx-auto px-6 py-2.5 text-center transition-opacity duration-500">
        {MESSAGES[i]}
      </div>
    </div>
  );
}
